import { combineReducers } from "redux";
import notification from "../features/admin/notification/Slice";

const NotificationData = combineReducers({
  notification: notification,
});

export default NotificationData;
